import { v4 as uuidv4 } from 'uuid';
import { assignPublisherColors } from '../../../../commons/utils/publisherColors';
import { getDiscoverPublishersAPI } from './api';
import fallbackData from './data/directory-publishers.json';
import staticIndustries from './data/directory-industries.json';

async function getDirectoryPublishers() {
    const session = this.env.session;
    const traceId = this.env.traceId;

    this.directoryFilterIndustries = staticIndustries;
    this.observed.directoryPublishers = uuidv4();

    const res = await getDiscoverPublishersAPI({ token: session?.token, traceId });
    const data = res?.data?.data || res?.data || null;
    const publishers = data?.publishers || [];

    if (publishers.length === 0) {
        this.masterDirectoryPublishers = fallbackData.publishers;
        this.directoryPublishers = fallbackData.publishers;
        this.observed.directoryPublishers = uuidv4();
        return;
    }

    const colored = assignPublisherColors(publishers);
    this.masterDirectoryPublishers = colored;
    this.directoryPublishers = colored;
    this.observed.directoryPublishers = uuidv4();
}

export default getDirectoryPublishers;
